import {Field} from "./Field";
import EvoCheckbox from "../../components/form/fields/EvoCheckbox";

export class Checkbox extends Field {
    constructor() {
        super();
        this._component = EvoCheckbox;
        this._true_value = true;
        this._false_value = false;
    }

    trueValue(value) {
        this._true_value = value;
        return this;
    }

    falseValue(value) {
        this._false_value = value;
        return this;
    }
}
